import { api } from "../../../utils/api";

// Fetch all DC OUTs
export const fetchDcOuts = async () => {
  const res = await api.get("/dc-outs");
  return res.data.data ?? res.data; 
};

// Create DC OUT
export const createDcOut = async (payload) => {
  const res = await api.post("/dc-outs", payload);
  return res.data;
};